export { ThemedSection } from './ThemedSection';
export type { ThemedSectionProps } from './ThemedSection.types';
